import React, { useState, useCallback } from "react";
import Button from "@material-ui/core/Button";
import type { FC } from "react";
import { Dialog } from "./Dialog";
import { useStyles } from "./SaveBulkExportStateButton.styles";
import { useSaveSettingsButton } from "./SaveBulkExportStateButton.state";
import { useBulkExportContext } from "../../providers";

export const SaveBulkExportStateButton: FC = () => {
  const classes = useStyles();
  const { saveExistExportSettings } = useSaveSettingsButton();
  const [openDialog, setOpenDialog] = useState(false);
  const handleCloseDialog = useCallback(() => setOpenDialog(false), [setOpenDialog]);
  const context = useBulkExportContext();
  const settingsWasModified = context?.state.settingsWasModified;
  const setSettingsWasModified = context?.actions.setSettingsWasModified;
  
  const handleClick = useCallback(() => {
    setSettingsWasModified && setSettingsWasModified(false)
    saveExistExportSettings();
    setOpenDialog(true);
    
  }, [setOpenDialog, saveExistExportSettings, setSettingsWasModified]);

  return (
    <>
      <Dialog open={openDialog} onCancel={handleCloseDialog}/>
      <Button color="primary" variant="contained" onClick={handleClick} classes={classes} disabled={!settingsWasModified}>
        Save
      </Button>
    </>
  );
};
